import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import axios from '../../../utils/axios';
import OutreachScopeContext from '../../../contexts/OutreachScopeContext';
import { usePageCampus } from '../../../contexts/PageCampusContext';
import OutreachOnboardingDialog from './components/OutreachOnboardingDialog';
import useAuth from '../../../hooks/useAuth';

export default function OutreachLayout() {
  const [scope, setScope] = useState('per_campus');
  const [loading, setLoading] = useState(true);
  const { setPageCampusMode } = usePageCampus();
  const { user, updateUser } = useAuth();

  const [onboardingOpen, setOnboardingOpen] = useState(false);

  useEffect(() => {
    axios.get('/api/v1/em/settings/')
      .then(r => setScope(r.data.scope_mode || 'per_campus'))
      .catch(() => {})
      .finally(() => setLoading(false));
    return () => setPageCampusMode(false);
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!loading) setPageCampusMode(scope === 'org_wide');
  }, [scope, loading]); // eslint-disable-line react-hooks/exhaustive-deps

  // Open once user is loaded and hasn't seen outreach onboarding
  useEffect(() => {
    if (user && !user.onboarding?.outreach) {
      setOnboardingOpen(true);
    }
  }, [user]);

  const handleOnboardingClose = async () => {
    setOnboardingOpen(false);
    try {
      const r = await axios.post('/api/v1/accounts/user/onboarding/seen/', { slug: 'outreach' });
      // Patch the auth context so user.onboarding stays in sync without a re-login
      if (updateUser) updateUser({ ...user, onboarding: r.data.onboarding });
    } catch (e) {
      console.error('Failed to mark onboarding seen', e);
    }
  };

  return (
    <OutreachScopeContext.Provider value={{
      scope,
      isOrgWide: scope === 'org_wide',
      loading,
      setScope,
    }}>
      <Outlet />
      <OutreachOnboardingDialog open={onboardingOpen} onClose={handleOnboardingClose} />
    </OutreachScopeContext.Provider>
  );
}
